(function () {
  var data = document.getElementById('nv-delivery-data');
  if (!data) return;
  var config = JSON.parse(data.textContent);
  var pending;
  async function post(path, body) {
    var response = await fetch(config.root + path, {
      method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)
    });
    if (!response.ok) throw new Error('cart update');
    return response.json();
  }
  // Both bundles include priority delivery; every other report product is
  // sold on its own and may need it (27 Oct 2026).
  var BUNDLES = ['nuvora-complete-bundle','nuvora-full-upgrade'];
  var REPORTS = BUNDLES.concat(['nuvora-complete-blueprint','nuvora-hairstyle-recommendations','nuvora-makeup-recommendations','nuvora-grooming-eyewear-recommendations']);
  async function normalize() {
    var response = await fetch(config.root + 'cart.js', {cache:'no-store'});
    if (!response.ok) throw new Error('cart');
    var cart = await response.json();
    var pair = cart.items.filter(function(i) { return i.properties && i.properties._nuvora_complete === 'pair'; });
    function count(handle) { return pair.filter(function(i) { return i.handle === handle; }).reduce(function(n,i) { return n+i.quantity; },0); }
    var bases = count('nuvora-complete-blueprint');
    var hairs = count('nuvora-hairstyle-recommendations');
    if (bases !== hairs) {
      for (var item of pair) {
        var properties = Object.assign({},item.properties);
        properties.Delivery = '';
        properties.Plan = '';
        properties._nuvora_complete = '';
        await post('cart/change.js',{id:item.key,quantity:item.quantity,properties:properties});
      }
      return true;
    }
    var complete = bases > 0 || cart.items.some(function(i) { return BUNDLES.indexOf(i.handle) !== -1; });
    var standard = cart.items.some(function(i) { return REPORTS.indexOf(i.handle) !== -1 && BUNDLES.indexOf(i.handle) === -1 && !(i.properties && i.properties._nuvora_complete === 'pair'); });
    var updates = {};
    if (complete && !standard) cart.items.forEach(function(i) {
      if (i.handle === 'priority-delivery') updates[i.key] = 0;
    });
    if (Object.keys(updates).length) {
      await post('cart/update.js',{updates:updates});
      return true;
    }
    return false;
  }
  function check() {
    if (!pending) pending = normalize().finally(function() { pending = null; });
    return pending;
  }
  function showError() {
    document.querySelectorAll('[data-nv-cart-delivery]').forEach(function(container) {
      var el=container.querySelector('[data-nv-delivery-status]');
      if (!el) {
        el=document.createElement('p');
        el.setAttribute('data-nv-delivery-status','');
        el.setAttribute('role','alert');
        container.appendChild(el);
      }
      el.textContent=config.error;
    });
  }
  function refreshIfChanged(changed) { if (changed) window.location.assign(config.root+'cart'); }
  document.addEventListener('click', function(event) {
    var button=event.target.closest('[data-nv-remove-priority]');
    if (!button) return;
    button.disabled=true;
    check().then(refreshIfChanged).catch(showError).finally(function() { button.disabled=false; });
  });
  // A bundle and one of its own parts for the same person: remove the
  // separate line only when the customer asks, since it may be a gift.
  document.addEventListener('click', async function(event) {
    var button=event.target.closest('[data-nv-remove-dupes]');
    if (!button) return;
    var updates={};
    button.getAttribute('data-nv-remove-dupes').split(',').filter(Boolean).forEach(function(key) { updates[key]=0; });
    button.disabled=true;
    try {
      await post('cart/update.js',{updates:updates});
      refreshIfChanged(true);
    } catch(error) { showError(); button.disabled=false; }
  });
  document.addEventListener('submit', async function(event) {
    var form=event.target;
    if (form.id !== 'cart-form' || form.dataset.nvDeliveryChecked) return;
    if (!document.querySelector('[data-nv-cart-delivery]')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    event.preventDefault();
    var button=event.submitter;
    if (button) button.setAttribute('aria-busy','true');
    try {
      if (await check()) { refreshIfChanged(true); return; }
      form.dataset.nvDeliveryChecked='true';
      if (button) form.requestSubmit(button);
      else window.location.assign(config.root+'checkout');
    } catch(error) { showError(); }
    finally { if (button) button.removeAttribute('aria-busy'); }
  },true);
  if (window.location.pathname.replace(/\/$/,'') === (config.root+'cart').replace(/\/$/,'')) {
    check().then(refreshIfChanged).catch(showError);
  }
  document.addEventListener('cart:update',function() { check().then(refreshIfChanged).catch(showError); });
})();
